import styled, { css, keyframes } from 'styled-components';
import { ICON_SIZES, STATES } from '../constants';
import { styleByState } from '../helpers';
import { wizardTheme } from '../theme';

const BORDER_WIDTH = 2;

const borderColor = styleByState({
  [STATES.DISABLED]: wizardTheme.connector.color.disabled,
  [STATES.ERROR]: wizardTheme.connector.color.error,
  [STATES.COMPLETED]: wizardTheme.connector.color.completed,
  [STATES.ACTIVE]: wizardTheme.connector.color.incomplete, //We have animation for the active color, this is the base color
  [STATES.INCOMPLETE]: wizardTheme.connector.color.incomplete,
});

const borderAnimation = keyframes`
  from {width: 0}
  to { width: 100% }
`;

const activeAnimation = styleByState({
  [STATES.ACTIVE]: css`
    &:before {
      content: ' ';
      top: -${BORDER_WIDTH}px;
      width: 0;
      border-top: ${BORDER_WIDTH}px solid ${wizardTheme.connector.color.active};
      position: absolute;
      animation: ${borderAnimation} 0.2s ease-in-out forwards;
    }
  `,
});

const Connector = styled.div`
  top: ${ICON_SIZES.ACTIVE / 2}px;
  left: calc(-50% + ${ICON_SIZES.ACTIVE / 2}px);
  right: calc(50% + ${ICON_SIZES.ACTIVE / 2}px);
  position: absolute;
  border-top: ${BORDER_WIDTH}px solid ${borderColor};
  flex-grow: 1;
  margin: 0 5px;
  ${activeAnimation}
`;

export default Connector;
